import { derived, get, writable } from 'svelte/store';
import { getDictionaryDetails } from './glosbe-dictionary-api/glosbe-dictionary-service';
import { createDummyLanguage, getLanguage, getLanguageImmediately } from './languages.service';
export const dictionaryDescription = writable(null);
export const l1Description = derived(dictionaryDescription, (description => {
    if (description) {
        return description.source;
    }
    return null;
}));
export const l2Description = derived(dictionaryDescription, (description => {
    if (description) {
        return description.target;
    }
    return null;
}));
function getElementValueIfPresent(id, defaultValue) {
    const element = document.getElementById(id);
    let ret = defaultValue;
    if (element) {
        const value = element.value;
        if (value) {
            ret = value;
        }
    }
    return ret;
}
const glosbeGlobalState = window.glosbe || { dictionary: {} };
export function getCurrentDictionaryLabel() {
    const currentDictionary = get(dictionary);
    if (currentDictionary) {
        return `${currentDictionary.l1.code}:${currentDictionary.l2.code}`;
    }
    return "";
}
export const dictionary = writable({
    l1: glosbeGlobalState.dictionary.l1 || createDummyLanguage('en', 'English'),
    l2: glosbeGlobalState.dictionary.l2 || createDummyLanguage('en', 'English'),
});
export function updateDictionary({ l1, l2 }) {
    dictionary.set({ l1, l2 });
}
export function swapDictionaryLanguages() {
    dictionary.update(currentDictionary => ({
        l1: currentDictionary.l2,
        l2: currentDictionary.l1
    }));
}
export function updateDictionaryByCodes(l1Code, l2Code) {
    const getLanguageImmediatelyGetter = get(getLanguageImmediately);
    const l1 = getLanguageImmediatelyGetter(l1Code);
    const l2 = getLanguageImmediatelyGetter(l2Code);
    dictionary.set({ l1, l2 });
    if (l1.dummy || l2.dummy) {
        const getLanguageGetter = get(getLanguage);
        Promise.all([getLanguageGetter(l1Code), getLanguageGetter(l2Code)]).then(languages => {
            const currentDictionary = get(dictionary);
            const newDictionary = Object.assign({}, currentDictionary);
            let shouldUpdateDictionary = false;
            if (currentDictionary.l1.code === languages[0].code && currentDictionary.l1.dummy) {
                newDictionary.l1 = languages[0];
                shouldUpdateDictionary = true;
            }
            if (currentDictionary.l2.code === languages[1].code && currentDictionary.l2.dummy) {
                newDictionary.l2 = languages[1];
                shouldUpdateDictionary = true;
            }
            if (shouldUpdateDictionary) {
                dictionary.set(newDictionary);
            }
        });
    }
}
export function loadDictionary({ l1, l2 }) {
    const lang1 = { code: l1, name: l1 };
    const lang2 = { code: l2, name: l2 };
    dictionary.set({ l1: lang1, l2: lang2 });
    return new Promise((resolve, reject) => {
        getDictionaryDetails({ l1, l2 }).then(result => {
            dictionaryDescription.set(result);
            dictionary.set({ l1: result.source.data || lang1, l2: result.target.data || lang2 });
            resolve(result);
        }).catch(reject);
    });
}
